import React, { useState, useEffect, useRef } from "react";
import { Select, DatePicker, message } from "antd";
import moment from "moment";
import JobStatusService from "../../../Services/JobStatusService";
import Repeater from "./Repeater";
import ExpRepeater from "./ExpRepeater";
import DataParser from "../../../utlits/Dataparser";
import { Link, useNavigate } from "react-router-dom";
import CompanyService from "../../../Services/CompanyService";
import secureLocalStorage from "react-secure-storage";
import { Eye, EyeOff } from "lucide-react";
import { NATIONALITIES, BLOOD_GROUPS, RELIGIONS } from "../../../utlits/constants";
import DesignationService from "../../../Services/DesignationService";

const { Option } = Select;

const AddUsers = () => {
  const navigate = useNavigate();
  const [inputFields, setInputFields] = useState([{ degree_title: "", institue: "", end_date: "" }]);
  const [ExpInputFields, setExpInputFields] = useState([{ organization_title: "", designation: "", start_date: "", end_date: "", last_salary: "" }]);

  const addExpFiled = () => setExpInputFields([...ExpInputFields, { organization_title: "", designation: "", start_date: "", end_date: "", last_salary: "" }]);
  const addFields = () => setInputFields([...inputFields, { degree_title: "", institue: "", end_date: "" }]);

  const [dataSubmitting, setDataSubmitting] = useState(false);
  const [preview, setPreview] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfrimPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [gender, setGender] = useState("");
  const [role, setRole] = useState("");
  const [BusinessPhones, setBusinessPhone] = useState("");
  const [personalMobile, setPersonalMobile] = useState("");
  const [spouse, setSpouse] = useState("");
  const [personalEmail, setPersonalEmail] = useState("");
  const [landLine, setLandline] = useState("");
  const [currentAddress, setCurrentAddress] = useState("");
  const [permanentAddress, setPermanentAddress] = useState("");
  const [nationality, setNationality] = useState("");
  const [emergencyContactName, setEmergencyContactName] = useState("");
  const [emergencyContactPhone, setEmergenctContactPhone] = useState("");
  const [dob, setDob] = useState("");
  const [cnic, setCnic] = useState("");
  const [spouseCnic, setSpouseCnic] = useState("");
  const [maritalStatus, setMaritalStatus] = useState("");
  const [religion, setReligion] = useState("");
  const [bloodGroup, setBloodGroup] = useState("");
  const [personPic, setPersonalPic] = useState(null);
  const [department, setDepartment] = useState("");
  const [isHead, setIsHead] = useState("");
  const [phoneExt, setPhoneExt] = useState("");
  const [relativeInWebsouls, setRealtionInWebsouls] = useState("");
  const [employmentStatus, setEmploymentStatus] = useState("");
  const [dateOfjoining, setDateofJoining] = useState("");
  const [reportsTo, setReportsTo] = useState("");
  const [designation, setDesignation] = useState("");
  const [empid, setEmpId] = useState("");
  const [attachments, setAttachments] = useState([]);

  const [EmailError, setEmailError] = useState("");
  const [PasswordError, setPasswordError] = useState("");
  const [ConfirmPasswordError, setConfirmPasswordError] = useState("");
  const [FirstNameError, setFirstNameError] = useState("");
  const [LastNameError, setLastNameError] = useState("");
  const [GenderError, setGenderError] = useState("");
  const [RoleError, setRoleError] = useState("");
  const [SpouseError, setSpouseError] = useState("");
  const [personalEmailError, setpersonalEmailError] = useState("");
  const [PersonalMobileError, setPersonalMobileError] = useState("");
  const [CurrentAddressError, setCurrentAddressError] = useState("");
  const [NationalityError, setNationalityError] = useState("");
  const [DOBError, setDOBError] = useState("");
  const [DepartmentError, setDepartmentError] = useState("");
  const [DesignationError, setDesignationError] = useState("");
  const [RelativeWebsoulsError, setRelativeWebsoulsError] = useState("");
  const [EmployementStatusError, setEmployementStatusError] = useState("");
  const [ReportsToError, setReportsToError] = useState("");
  const [CNICError, setCNICError] = useState("");

  const fileInputRef = useRef(null);
  const fileInputRefMul = useRef(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [rolesList, setRolesList] = useState([]);
  const [deparmentList, setDepartmentList] = useState([]);
  const [ReportList, setReportList] = useState([]);
  const [employmentStatusList, setEmploymentStatusList] = useState([]);
  const [designationList, setDesignationList] = useState([]);

  const [activeTab, setActiveTab] = useState(0);
  const TABS = [
    { label: "Login Credentials", icon: "uil-lock" },
    { label: "Personal Info", icon: "uil-user-circle" },
    { label: "Official Info", icon: "uil-briefcase" },
    { label: "Academic Records", icon: "uil-graduation-cap" },
    { label: "Work Experience", icon: "uil-suitcase" },
    { label: "Documents", icon: "uil-paperclip" },
  ];

  const isSubmitting = useRef(false);
  const draftDataRef = useRef({});

  // kept for ExpRepeater
  const customStyles = {
    control: (provided, state) => ({ ...provided, border: state.isFocused ? "1px solid #0DDFAB" : "1px solid #e1e5eb", borderRadius: "10px", minHeight: "40px", height: "40px", boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(13, 223, 171, 0.25)" : "none", fontSize: "14px", "&:hover": { border: state.isFocused ? "1px solid #0DDFAB" : "1px solid #e1e5eb" } }),
    valueContainer: (provided) => ({ ...provided, padding: "0 15px", height: "40px", display: "flex", alignItems: "center" }),
    input: (provided) => ({ ...provided, margin: "0px", padding: "0px", caretColor: "black", color: "black", boxShadow: "none !important", outline: "none !important", border: "none !important", background: "transparent" }),
    singleValue: (provided) => ({ ...provided, margin: "0px" }),
    indicatorsContainer: (provided) => ({ ...provided, height: "40px" }),
    indicatorSeparator: () => ({ display: "none" }),
    placeholder: (provided) => ({ ...provided, color: "#6c757d" }),
    option: (provided, state) => ({ ...provided, backgroundColor: state.isSelected ? "#0DDFAB" : state.isFocused ? "rgba(13, 223, 171, 0.1)" : "transparent", color: state.isSelected ? "white" : "black", cursor: "pointer", "&:active": { backgroundColor: "#0DDFAB" }, zIndex: 9999 }),
    menu: (provided) => ({ ...provided, zIndex: 9999 }),
  };

  const designationOptions = designationList.map((el) => ({ value: el.name, label: el.name }));

  useEffect(() => {
    draftDataRef.current = { relativeInWebsouls, employmentStatus, dateOfjoining, reportsTo, isHead, empid };
  }, [firstName, lastName, gender, email, role, personalMobile, dob, currentAddress, spouse, designation, personalEmail, landLine, permanentAddress, nationality, emergencyContactName, emergencyContactPhone, cnic, spouseCnic, maritalStatus, religion, bloodGroup, department, relativeInWebsouls, employmentStatus, dateOfjoining, reportsTo, isHead, empid]);

  const saveDraft = () => {
    const data = draftDataRef.current;
    if (!data.email || isSubmitting.current) return;
    const companyId = DataParser.CompanyId();
    const formdata = new FormData();
    formdata.append("first_name", data.firstName);
    formdata.append("last_name", data.lastName);
    formdata.append("gender", data.gender);
    formdata.append("email", data.email);
    formdata.append("role", data.role);
    formdata.append("status", 0);
    formdata.append("mobile_no", data.personalMobile);
    formdata.append("dob", data.dob);
    formdata.append("address", data.currentAddress);
    formdata.append("user_type", "company");
    formdata.append("company_id", companyId);
    formdata.append("relative_websouls", data.relativeInWebsouls);
    formdata.append("employment_status", data.employmentStatus);
    formdata.append("joining_date", data.dateOfjoining);
    formdata.append("report_to", data.reportsTo);
    formdata.append("is_head", data.isHead);
    formdata.append("empid", data.empid);
    const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:5026";
    fetch(baseUrl + "/api/v1/user/create", { method: "POST", body: formdata, keepalive: true, headers: { "authToken": DataParser.AuthToken() } });
  };

  useEffect(() => {
    window.addEventListener("beforeunload", saveDraft);
    return () => { window.removeEventListener("beforeunload", saveDraft); saveDraft(); };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const companyId = DataParser.CompanyId();
    CompanyService.getCompanyRoles(companyId).then((res) => {
      if (res.data === "Un-Athunticated request") { secureLocalStorage.removeItem("adminInfo"); secureLocalStorage.removeItem("admins"); navigate("/"); return; }
      setRolesList(res.data.roles);
    });
    CompanyService.getCompanyDepartment(companyId).then((res) => {
      if (res.data === "Un-Athunticated request") { secureLocalStorage.removeItem("adminInfo"); secureLocalStorage.removeItem("admins"); navigate("/"); return; }
      setDepartmentList(res.data.departments);
    });
    CompanyService.getCompanyReportsTo(companyId).then((res) => {
      if (res.data === "Un-Athunticated request") { secureLocalStorage.removeItem("adminInfo"); secureLocalStorage.removeItem("admins"); navigate("/"); return; }
      setReportList(res.data.user);
    });
    JobStatusService.getJobStatusService(companyId).then((res) => {
      if (res.data === "Un-Athunticated request") { secureLocalStorage.removeItem("adminInfo"); secureLocalStorage.removeItem("admins"); navigate("/"); return; }
      setEmploymentStatusList(res.data.jobstatus);
    });
    DesignationService.getCompanyDesignation(companyId).then((res) => {
      if (res.data === "Un-Athunticated request") { secureLocalStorage.removeItem("adminInfo"); secureLocalStorage.removeItem("admins"); navigate("/"); return; }
      setDesignationList(res.data?.designations || []);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const emailRef = useRef();
  const passwordRef = useRef();
  const confirmPasswordRef = useRef();
  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const spouseRef = useRef();
  const personalEmailRef = useRef();
  const personalMobileRef = useRef();
  const currentAddressRef = useRef();
  const dobRef = useRef();
  const cnicRef = useRef();

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/;
    if (!newPassword) { setPasswordError(""); }
    else if (!passwordRegex.test(newPassword)) { setPasswordError("Password must be at least 8 characters with 1 uppercase, 1 number, and 1 special character!"); }
    else { setPasswordError(""); }
    if (confirmPassword && newPassword !== confirmPassword) { setConfirmPasswordError("Passwords do not match!"); }
    else if (confirmPassword) { setConfirmPasswordError(""); }
  };

  const handleConfirmPasswordChange = (e) => {
    const newConfirmPassword = e.target.value;
    setConfrimPassword(newConfirmPassword);
    if (newConfirmPassword && newConfirmPassword !== password) { setConfirmPasswordError("Passwords do not match!"); }
    else { setConfirmPasswordError(""); }
  };

  const handelSubmit = (e) => {
    e.preventDefault();
    isSubmitting.current = true;
    setDataSubmitting(true);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email)) { setEmailError("Please enter a valid email address!"); emailRef.current?.focus(); setDataSubmitting(false); isSubmitting.current = false; return; }
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/;
    if (!password || !passwordRegex.test(password)) { setPasswordError("Password must be at least 8 characters with 1 uppercase, 1 number, and 1 special character!"); passwordRef.current?.focus(); setDataSubmitting(false); isSubmitting.current = false; return; }
    if (password !== confirmPassword) { setConfirmPasswordError("Passwords do not match!"); confirmPasswordRef.current?.focus(); setDataSubmitting(false); isSubmitting.current = false; return; }
    if (!firstName.trim()) { setFirstNameError("First name is required!"); firstNameRef.current?.focus(); setDataSubmitting(false); isSubmitting.current = false; return; }
    if (!lastName.trim()) { setLastNameError("Last name is required!"); lastNameRef.current?.focus(); setDataSubmitting(false); isSubmitting.current = false; return; }
    if (!gender) { setGenderError("Gender is required!"); setDataSubmitting(false); isSubmitting.current = false; return; }
    if (!role) { setRoleError("Please select a role!"); setDataSubmitting(false); isSubmitting.current = false; return; }
    if (!spouse || spouse.trim() === "") { setSpouseError("Father/Spouse name is required!"); spouseRef.current?.focus(); setDataSubmitting(false); isSubmitting.current = false; return; }
    if (!personalEmail || !emailRegex.test(personalEmail)) { setpersonalEmailError("Please enter a valid personal email!"); personalEmailRef.current?.focus(); setDataSubmitting(false); isSubmitting.current = false; return; }
    if (!personalMobile || personalMobile.trim().length < 10) { setPersonalMobileError("Please enter a valid mobile number (at least 10 digits)!"); personalMobileRef.current?.focus(); setDataSubmitting(false); isSubmitting.current = false; return; }
    if (!currentAddress.trim()) { setCurrentAddressError("Current address is required!"); currentAddressRef.current?.focus(); setDataSubmitting(false); isSubmitting.current = false; return; }
    if (!nationality.trim()) { setNationalityError("Nationality is required!"); setDataSubmitting(false); isSubmitting.current = false; return; }
    if (!dob) { setDOBError("Date of birth is required!"); dobRef.current?.focus(); setDataSubmitting(false); isSubmitting.current = false; return; }
    if (!cnic || cnic.trim().length !== 13) { setCNICError("Please enter a valid 13-digit CNIC!"); cnicRef.current?.focus(); setDataSubmitting(false); isSubmitting.current = false; return; }
    if (!department) { setDepartmentError("Department is required!"); setDataSubmitting(false); isSubmitting.current = false; return; }
    if (!designation) { setDesignationError("Designation is required!"); setDataSubmitting(false); isSubmitting.current = false; return; }
    if (!relativeInWebsouls) { setRelativeWebsoulsError("Please specify if you have any relative in the company!"); setDataSubmitting(false); isSubmitting.current = false; return; }
    if (!employmentStatus) { setEmployementStatusError("Employment status is required!"); setDataSubmitting(false); isSubmitting.current = false; return; }
    if (!reportsTo) { setReportsToError("Please select a reporting manager!"); setDataSubmitting(false); isSubmitting.current = false; return; }

    const companyId = DataParser.CompanyId();
    const formdata = new FormData();
    formdata.append("company_id", companyId);
    formdata.append("email", email);
    formdata.append("password", password);
    formdata.append("confirm-password", confirmPassword);
    formdata.append("first_name", firstName);
    formdata.append("last_name", lastName);
    formdata.append("gender", gender);
    formdata.append("role", role);
    formdata.append("spouse_name", spouse);
    formdata.append("personal_email", personalEmail);
    formdata.append("personal_mobile", personalMobile);
    formdata.append("personal_land_line_no", landLine);
    formdata.append("personal_current_address", currentAddress);
    formdata.append("personal_permanent_address", permanentAddress);
    formdata.append("personal_nationality", nationality);
    formdata.append("designation", designation);
    formdata.append("personal_emg_contact_name", emergencyContactName);
    formdata.append("personal_emg_contact_phone", emergencyContactPhone);
    formdata.append("dob", dob);
    formdata.append("personal_cnic", cnic);
    formdata.append("personal_parent_cnic", spouseCnic);
    formdata.append("personal_marital_status", maritalStatus);
    formdata.append("personal_religion", religion);
    formdata.append("personal_blood_group", bloodGroup);
    formdata.append("department", department);
    formdata.append("is_head", isHead);
    formdata.append("buisness_phone", BusinessPhones);
    formdata.append("phone_ext", phoneExt);
    formdata.append("relative_websouls", relativeInWebsouls);
    formdata.append("employment_status", employmentStatus);
    formdata.append("joining_date", dateOfjoining);
    formdata.append("report_to", reportsTo);
    formdata.append("empid", empid);
    if (personPic) formdata.append("file", personPic);
    formdata.append("academic", JSON.stringify(inputFields));
    formdata.append("experience", JSON.stringify(ExpInputFields));

    CompanyService.createCompanyUser(formdata, { headers: { "Content-Type": "multipart/form-data" } })
      .then((res) => {
        if (res.data === "Un-Athunticated request") { secureLocalStorage.removeItem("adminInfo"); secureLocalStorage.removeItem("admins"); navigate("/"); setDataSubmitting(false); isSubmitting.current = false; return; }
        if (res.Good) {
          const userId = res.user_id;
          const formData = new FormData();
          if (attachments && attachments.length > 0) attachments.forEach((file) => formData.append("files", file.file));
          CompanyService.createCompanyUserDoc(userId, formData, { headers: { "Content-Type": "multipart/form-data" } })
            .then(() => { message.success("User created successfully!"); setDataSubmitting(false); navigate(`/${DataParser.CompanyIdentifierRole()}/users`); })
            .catch(() => { message.warning("User created, but document upload failed!"); setDataSubmitting(false); navigate(`/${DataParser.CompanyIdentifierRole()}/users`); });
        } else { message.error("Failed to create user. Please try again!"); setDataSubmitting(false); isSubmitting.current = false; }
      })
      .catch((err) => { message.error("Something went wrong. Please try again later!"); setDataSubmitting(false); isSubmitting.current = false; });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setPersonalPic(file);
    if (file) setPreview(URL.createObjectURL(file));
  };

  const handleDownload = () => {
    if (personPic) { const link = document.createElement("a"); link.href = preview; link.download = personPic.name || "downloaded-image.jpg"; link.click(); }
  };

  const handleRemove = () => {
    setPersonalPic(null); setPreview(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleFileChangeMultiple = (e) => {
    const files = Array.from(e.target.files || []);
    const mapped = files.map((file) => ({ file, preview: file.type.startsWith("image/") ? URL.createObjectURL(file) : null }));
    setAttachments((prev) => [...prev, ...mapped]);
    if (fileInputRefMul.current) fileInputRefMul.current.value = "";
  };

  const handleDownloadMultiple = (file, preview) => {
    const link = document.createElement("a"); link.href = preview || URL.createObjectURL(file); link.download = file.name; link.click();
  };

  const handleRemoveMultiple = (index) => {
    const newAttachments = [...attachments]; newAttachments.splice(index, 1); setAttachments(newAttachments);
    if (newAttachments.length === 0 && fileInputRefMul.current) fileInputRefMul.current.value = "";
  };

  const fileIcons = { pdf: "📕", doc: "📘", docx: "📘", xls: "📗", xlsx: "📗", csv: "📗", txt: "📄", default: "📁" };

  const sectionHeader = (icon, title) => (
    <h5 className="mb-4" style={{ borderBottom: "2px solid #0bc698", paddingBottom: "10px", fontWeight: 700, color: "#000" }}>
      <i className={`${icon} me-2`}></i>{title}
    </h5>
  );

  return (
    <>
      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 px-0 d-flex justify-content-end" style={{ padding: "4px 0 8px" }}>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item"><Link to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}>Home</Link></li>
                  <li className="breadcrumb-item"><Link to={`/${DataParser.CompanyIdentifierRole()}/users`}>All Employees</Link></li>
                  <li className="breadcrumb-item active">Add Employee</li>
                </ol>
              </div>
            </div>

            {/* ── Tab Bar ── */}
            <div className="user-form-tab-bar" style={{ marginTop: "16px" }}>
              <div style={{ display: "flex", flex: 1 }}>
                {TABS.map((tab, i) => (
                  <div key={i} className={`user-form-tab${activeTab === i ? " active" : ""}`} onClick={() => setActiveTab(i)}>
                    <i className={tab.icon} />
                    {tab.label}
                  </div>
                ))}
              </div>
              {activeTab < TABS.length - 1 ? (
                <button type="button" onClick={() => setActiveTab(activeTab + 1)} style={{ background: "#1D1D1D", color: "#fff", border: "none", borderRadius: "6px", padding: "8px 22px", fontWeight: 600, fontSize: "14px", cursor: "pointer", marginLeft: "16px", whiteSpace: "nowrap" }}>
                  Next
                </button>
              ) : dataSubmitting ? (
                <button disabled style={{ background: "#0bc698", color: "#fff", border: "none", borderRadius: "6px", padding: "8px 22px", fontWeight: 600, fontSize: "14px", marginLeft: "16px", minWidth: "160px", cursor: "not-allowed" }}>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Submitting...
                </button>
              ) : (
                <button type="submit" form="add-user-form" style={{ background: "#0bc698", color: "#fff", border: "none", borderRadius: "6px", padding: "8px 22px", fontWeight: 600, fontSize: "14px", cursor: "pointer", marginLeft: "16px", whiteSpace: "nowrap" }}>
                  Create Employee
                </button>
              )}
            </div>

            <form id="add-user-form" onSubmit={handelSubmit}>

              {/* ── Tab 0: Login Credentials ── */}
              {activeTab === 0 && (
                <>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="float-input-wrap mb-3">
                        <input type="email" id="loginEmail" placeholder=" " ref={emailRef}
                          className={EmailError ? "is-invalid" : ""}
                          value={email} onChange={(e) => { setEmail(e.target.value); if (e.target.value.trim()) setEmailError(""); }} />
                        <label htmlFor="loginEmail">Login Email*</label>
                        {EmailError && <small className="text-danger mt-1 d-block">{EmailError}</small>}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="float-input-wrap mb-3" style={{ position: "relative" }}>
                        <input type={showPassword ? "text" : "password"} id="password" placeholder=" " ref={passwordRef}
                          className={PasswordError ? "is-invalid" : ""}
                          style={{ paddingRight: "44px" }}
                          value={password} onChange={handlePasswordChange} />
                        <label htmlFor="password">Password*</label>
                        <button type="button" onClick={() => setShowPassword(!showPassword)} style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#6c757d", zIndex: 2 }}>
                          {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                        </button>
                        {PasswordError && <small className="text-danger mt-1 d-block">{PasswordError}</small>}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="float-input-wrap mb-3" style={{ position: "relative" }}>
                        <input type={showConfirmPassword ? "text" : "password"} id="confirmPassword" placeholder=" " ref={confirmPasswordRef}
                          className={ConfirmPasswordError ? "is-invalid" : ""}
                          style={{ paddingRight: "44px" }}
                          value={confirmPassword} onChange={handleConfirmPasswordChange} />
                        <label htmlFor="confirmPassword">Confirm Password*</label>
                        <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)} style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#6c757d", zIndex: 2 }}>
                          {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                        </button>
                        {ConfirmPasswordError && <small className="text-danger mt-1 d-block">{ConfirmPasswordError}</small>}
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* ── Tab 1: Personal Info (User Info fields + Personal Info fields) ── */}
              {activeTab === 1 && (
                <>
                  <div className="row">
                    <div className="col-12 col-sm-4">
                      <div className="float-input-wrap mb-3">
                        <input type="text" id="firstName" placeholder=" " ref={firstNameRef}
                          className={FirstNameError ? "is-invalid" : ""}
                          value={firstName} onChange={(e) => { setFirstName(e.target.value); if (e.target.value.trim()) setFirstNameError(""); }} />
                        <label htmlFor="firstName">First Name*</label>
                        {FirstNameError && <small className="text-danger mt-1 d-block">{FirstNameError}</small>}
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="float-input-wrap mb-3">
                        <input type="text" id="lastName" placeholder=" " ref={lastNameRef}
                          className={LastNameError ? "is-invalid" : ""}
                          value={lastName} onChange={(e) => { setLastName(e.target.value); if (e.target.value.trim()) setLastNameError(""); }} />
                        <label htmlFor="lastName">Last Name*</label>
                        {LastNameError && <small className="text-danger mt-1 d-block">{LastNameError}</small>}
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                    <div className={`float-select-wrap mb-3 ${gender ? "has-value" : ""} ${GenderError ? " select-error" : ""}`}>
                        <label>Gender*</label>
                        <Select value={gender || undefined} onChange={(val) => { setGender(val); setGenderError(""); }} placeholder="" style={{ width: "100%" }}>
                          <Option value="Male">Male</Option>
                          <Option value="Female">Female</Option>
                          <Option value="Other">Other</Option>
                        </Select>
                        {GenderError && <small className="text-danger mt-1 d-block">{GenderError}</small>}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-sm-4">
                      <div className="float-input-wrap mb-3">
                        <input type="text" id="spouseName" placeholder=" " ref={spouseRef}
                          className={SpouseError ? "is-invalid" : ""}
                          value={spouse} onChange={(e) => { setSpouse(e.target.value); if (e.target.value.trim()) setSpouseError(""); }} />
                        <label htmlFor="spouseName">Spouse or Father's Name*</label>
                        {SpouseError && <small className="text-danger mt-1 d-block">{SpouseError}</small>}
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="float-input-wrap mb-3">
                        <input type="email" id="personalEmail" placeholder=" " ref={personalEmailRef}
                          className={personalEmailError ? "is-invalid" : ""}
                          value={personalEmail} onChange={(e) => { setPersonalEmail(e.target.value); if (e.target.value.trim()) setpersonalEmailError(""); }} />
                        <label htmlFor="personalEmail">Personal Email*</label>
                        {personalEmailError && <small className="text-danger mt-1 d-block">{personalEmailError}</small>}
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="float-input-wrap mb-3">
                        <input type="tel" id="personalMobile" placeholder=" " ref={personalMobileRef}
                          className={PersonalMobileError ? "is-invalid" : ""}
                          value={personalMobile} onChange={(e) => { const v = e.target.value.replace(/\D/g, ""); setPersonalMobile(v); if (v.trim()) setPersonalMobileError(""); }} />
                        <label htmlFor="personalMobile">Personal Mobile*</label>
                        {PersonalMobileError && <small className="text-danger mt-1 d-block">{PersonalMobileError}</small>}
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="float-input-wrap mb-3">
                        <input type="tel" id="landLine" placeholder=" "
                          value={landLine} onChange={(e) => setLandline(e.target.value.replace(/\D/g, ""))} />
                        <label htmlFor="landLine">Landline</label>
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="float-input-wrap mb-3">
                        <input type="text" id="currentAddress" placeholder=" " ref={currentAddressRef}
                          className={CurrentAddressError ? "is-invalid" : ""}
                          value={currentAddress} onChange={(e) => { setCurrentAddress(e.target.value); if (e.target.value.trim()) setCurrentAddressError(""); }} />
                        <label htmlFor="currentAddress">Current Address*</label>
                        {CurrentAddressError && <small className="text-danger mt-1 d-block">{CurrentAddressError}</small>}
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="float-input-wrap mb-3">
                        <input type="text" id="permanentAddress" placeholder=" "
                          value={permanentAddress} onChange={(e) => setPermanentAddress(e.target.value)} />
                        <label htmlFor="permanentAddress">Permanent Address</label>
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className={`float-select-wrap mb-3 ${nationality ? "has-value" : ""} ${NationalityError ? " select-error" : ""}`}>
                        <label>Nationality*</label>
                        <Select showSearch value={nationality || undefined} onChange={(val) => { setNationality(val); setNationalityError(""); }} placeholder="" style={{ width: "100%" }} filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                          {NATIONALITIES.map((nat) => <Option key={nat} value={nat}>{nat}</Option>)}
                        </Select>
                        {NationalityError && <small className="text-danger mt-1 d-block">{NationalityError}</small>}
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="float-input-wrap mb-3">
                        <input type="text" id="emergencyName" placeholder=" "
                          value={emergencyContactName} onChange={(e) => setEmergencyContactName(e.target.value)} />
                        <label htmlFor="emergencyName">Emergency Contact Name</label>
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="float-input-wrap mb-3">
                        <input type="tel" id="emergencyPhone" placeholder=" "
                          value={emergencyContactPhone} onChange={(e) => setEmergenctContactPhone(e.target.value.replace(/\D/g, ""))} />
                        <label htmlFor="emergencyPhone">Emergency Contact Phone</label>
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className={`float-select-wrap mb-3 ${dob ? "has-value" : ""} ${DOBError ? " select-error" : ""}`}>
                        <label>Date of Birth*</label>
                        <DatePicker style={{ width: "100%" }} format="DD-MM-YYYY"
                          placeholder=""
                          value={dob ? moment(dob, "YYYY-MM-DD") : null}
                          onChange={(val) => { setDob(val ? val.format("YYYY-MM-DD") : ""); if (val) setDOBError(""); }} />
                        {DOBError && <small className="text-danger mt-1 d-block">{DOBError}</small>}
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="float-input-wrap mb-3">
                        <input type="tel" id="cnic" placeholder=" " ref={cnicRef} maxLength="13"
                          className={CNICError ? "is-invalid" : ""}
                          value={cnic} onChange={(e) => { const v = e.target.value.replace(/\D/g, ""); setCnic(v); if (v.trim()) setCNICError(""); }} />
                        <label htmlFor="cnic">CNIC* (13 digits)</label>
                        {CNICError && <small className="text-danger mt-1 d-block">{CNICError}</small>}
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="float-input-wrap mb-3">
                        <input type="tel" id="spouseCnic" placeholder=" " maxLength="13"
                          value={spouseCnic} onChange={(e) => setSpouseCnic(e.target.value.replace(/\D/g, ""))} />
                        <label htmlFor="spouseCnic">Parent/Spouse CNIC</label>
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className={`float-select-wrap mb-3 ${maritalStatus ? "has-value" : ""}`}>
                        <label>Marital Status</label>
                        <Select value={maritalStatus || undefined} onChange={setMaritalStatus} placeholder="" style={{ width: "100%" }} allowClear>
                          <Option value="Single">Single</Option>
                          <Option value="Married">Married</Option>
                        </Select>
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className={`float-select-wrap mb-3 ${religion ? "has-value" : ""}`}>
                        <label>Religion</label>
                        <Select showSearch value={religion || undefined} onChange={setReligion} placeholder="" style={{ width: "100%" }} allowClear filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                          {RELIGIONS.map((rel) => <Option key={rel} value={rel}>{rel}</Option>)}
                        </Select>
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className={`float-select-wrap mb-3 ${bloodGroup ? "has-value" : ""}`}>
                        <label>Blood Group</label>
                        <Select value={bloodGroup || undefined} onChange={setBloodGroup} placeholder="" style={{ width: "100%" }} allowClear>
                          {BLOOD_GROUPS.map((bg) => <Option key={bg} value={bg}>{bg}</Option>)}
                        </Select>
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className={`float-select-wrap mb-2 ${personPic ? "has-value" : ""}`}>
                        <label>Upload Picture</label>
                        <div
                          style={{ height: "44px", border: "1.5px solid #d0d0d0", borderRadius: "8px", padding: "0 14px", display: "flex", alignItems: "center", fontSize: "14px", color: "#6c757d", background: "#fff", cursor: "pointer", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}
                          onClick={() => fileInputRef.current?.click()}
                        >
                          {personPic ? personPic.name : ""}
                        </div>
                        <input type="file" accept="image/*" onChange={handleFileChange} ref={fileInputRef} style={{ display: "none" }} />
                      </div>
                      {preview && (
                        <div className="mt-2">
                          <div title={personPic?.name} style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "#1e2030", borderRadius: "5px", padding: "5px 10px 5px 12px", fontSize: "13px", color: "#0bc698", maxWidth: "100%", fontWeight: 500 }}>
                            <i className="uil-import" style={{ fontSize: "14px", flexShrink: 0, cursor: "pointer" }} onClick={handleDownload} />
                            <span onClick={handleDownload} style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1, cursor: "pointer" }}>{personPic?.name}</span>
                            <span onClick={handleRemove} style={{ flexShrink: 0, cursor: "pointer", fontSize: "17px", lineHeight: 1, marginLeft: "2px" }}>×</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}

              {/* ── Tab 2: Official Info ── */}
              {activeTab === 2 && (
                <>
                  <div className="row">
                    <div className="col-12 col-sm-4">
                      <div className={`float-select-wrap mb-3 ${role ? "has-value" : ""} ${RoleError ? " select-error" : ""}`}>
                        <label>Role*</label>
                        <Select value={role || undefined} onChange={(val) => { setRole(val); setRoleError(""); }} placeholder="" style={{ width: "100%" }}>
                          {rolesList && rolesList.map((el) => <Option key={el.id} value={el.id}>{el.name}</Option>)}
                        </Select>
                        {RoleError && <small className="text-danger mt-1 d-block">{RoleError}</small>}
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="float-input-wrap mb-3">
                        <input type="text" id="empid" placeholder=" "
                          value={empid} onChange={(e) => setEmpId(e.target.value)} />
                        <label htmlFor="empid">Employee ID</label>
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className={`float-select-wrap mb-3 ${department ? "has-value" : ""} ${DepartmentError ? " select-error" : ""}`}>
                        <label>Department*</label>
                        <Select value={department || undefined} onChange={(val) => { setDepartment(val); setDepartmentError(""); }} placeholder="" style={{ width: "100%" }}>
                          {deparmentList && deparmentList.map((el) => <Option key={el.id} value={el.id}>{el.name}</Option>)}
                        </Select>
                        {DepartmentError && <small className="text-danger mt-1 d-block">{DepartmentError}</small>}
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="float-input-wrap mb-3">
                        <input type="tel" id="businessPhone" placeholder=" "
                          value={BusinessPhones} onChange={(e) => setBusinessPhone(e.target.value.replace(/\D/g, ""))} />
                        <label htmlFor="businessPhone">Business Phone</label>
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className={`float-select-wrap mb-3 ${designation ? "has-value" : ""} ${DesignationError ? " select-error" : ""}`}>
                        <label>Designation*</label>
                        <Select showSearch value={designation || undefined} onChange={(val) => { setDesignation(val || ""); if (val) setDesignationError(""); }} placeholder="" style={{ width: "100%" }} allowClear filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                          {designationList.map((el) => <Option key={el.name} value={el.name}>{el.name}</Option>)}
                        </Select>
                        {DesignationError && <small className="text-danger mt-1 d-block">{DesignationError}</small>}
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className={`float-select-wrap mb-3 ${isHead ? "has-value" : ""}`}>
                        <label>Is Head?</label>
                        <Select value={isHead || undefined} onChange={setIsHead} placeholder="" style={{ width: "100%" }} allowClear>
                          <Option value="yes">Yes</Option>
                          <Option value="no">No</Option>
                        </Select>
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className="float-input-wrap mb-3">
                        <input type="tel" id="phoneExt" placeholder=" "
                          value={phoneExt} onChange={(e) => setPhoneExt(e.target.value.replace(/\D/g, ""))} />
                        <label htmlFor="phoneExt">Phone Ext.</label>
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className={`float-select-wrap mb-3 ${relativeInWebsouls ? "has-value" : ""} ${RelativeWebsoulsError ? " select-error" : ""}`}>
                        <label>Any Relative In Websouls?*</label>
                        <Select value={relativeInWebsouls || undefined} onChange={(val) => { setRealtionInWebsouls(val); setRelativeWebsoulsError(""); }} placeholder="" style={{ width: "100%" }}>
                          <Option value="yes">Yes</Option>
                          <Option value="no">No</Option>
                        </Select>
                        {RelativeWebsoulsError && <small className="text-danger mt-1 d-block">{RelativeWebsoulsError}</small>}
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className={`float-select-wrap mb-3 ${employmentStatus ? "has-value" : ""} ${EmployementStatusError ? " select-error" : ""}`}>
                        <label>Employment Status*</label>
                        <Select value={employmentStatus || undefined} onChange={(val) => { setEmploymentStatus(val); setEmployementStatusError(""); }} placeholder="" style={{ width: "100%" }}>
                          {employmentStatusList && employmentStatusList.map((el) => <Option key={el.id} value={el.id}>{el.name}</Option>)}
                        </Select>
                        {EmployementStatusError && <small className="text-danger mt-1 d-block">{EmployementStatusError}</small>}
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className={`float-select-wrap mb-3 ${dateOfjoining ? "has-value" : ""}`}>
                        <label>Joining Date</label>
                        <DatePicker style={{ width: "100%" }} format="DD-MM-YYYY"
                          placeholder=""
                          value={dateOfjoining ? moment(dateOfjoining, "YYYY-MM-DD") : null}
                          onChange={(val) => setDateofJoining(val ? val.format("YYYY-MM-DD") : "")} />
                      </div>
                    </div>
                    <div className="col-12 col-sm-4">
                      <div className={`float-select-wrap mb-3 ${reportsTo ? "has-value" : ""} ${ReportsToError ? " select-error" : ""}`}>
                        <label>Reports To*</label>
                        <Select showSearch value={reportsTo || undefined} onChange={(val) => { setReportsTo(val); setReportsToError(""); }} placeholder="" style={{ width: "100%" }} filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                          {ReportList && ReportList.map((el) => <Option key={el.id} value={el.id}>{el.first_name} {el.last_name}</Option>)}
                        </Select>
                        {ReportsToError && <small className="text-danger mt-1 d-block">{ReportsToError}</small>}
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* ── Tab 3: Academic Records ── */}
              {activeTab === 3 && (
                <>
                  <div className="row">
                    <div className="repeater-default">
                      <Repeater inputFields={inputFields} setInputFields={setInputFields} addFields={addFields} />
                      <div className="form-group overflow-hidden row">
                        <div className="col-12 mb-3">
                          <button type="button" onClick={addFields} className="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1 add_new_user">
                            <span>+</span> Add More
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* ── Tab 4: Work Experience ── */}
              {activeTab === 4 && (
                <>
                  <div className="row">
                    <div className="repeater-default">
                      <ExpRepeater ExpInputFields={ExpInputFields} setExpInputFields={setExpInputFields} designationOptions={designationOptions} customStyles={customStyles} />
                      <div className="form-group overflow-hidden row">
                        <div className="col-12 mb-3">
                          <button type="button" onClick={addExpFiled} className="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1 add_new_user">
                            <span>+</span> Add More
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* ── Tab 5: Documents ── */}
              {activeTab === 5 && (
                <>
                  <div className="row">
                    <div className="col-12 col-sm-4">
                      <div className={`float-select-wrap mb-2 ${attachments.length > 0 ? "has-value" : ""}`}>
                        <label>Upload Files</label>
                        <div
                          style={{ height: "44px", border: "1.5px solid #d0d0d0", borderRadius: "8px", padding: "0 14px", display: "flex", alignItems: "center", fontSize: "14px", color: "#6c757d", background: "#fff", cursor: "pointer", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}
                          onClick={() => fileInputRefMul.current?.click()}
                        >
                          {attachments.length > 0 ? `${attachments.length} file(s) selected` : ""}
                        </div>
                        <input multiple type="file" onChange={handleFileChangeMultiple} ref={fileInputRefMul} style={{ display: "none" }} />
                      </div>
                      {attachments.length > 0 && (
                        <div className="d-flex flex-wrap mt-2" style={{ gap: "8px" }}>
                          {attachments.map((att, index) => (
                            <div key={index} title={att.file.name} style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "#1e2030", borderRadius: "5px", padding: "5px 10px 5px 12px", fontSize: "13px", color: "#0bc698", maxWidth: "240px", fontWeight: 500 }}>
                              <i className="uil-import" style={{ fontSize: "14px", flexShrink: 0, cursor: "pointer" }} onClick={() => handleDownloadMultiple(att.file, att.preview)} />
                              <span onClick={() => handleDownloadMultiple(att.file, att.preview)} style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1, cursor: "pointer" }}>{att.file.name}</span>
                              <span onClick={() => handleRemoveMultiple(index)} style={{ flexShrink: 0, cursor: "pointer", fontSize: "17px", lineHeight: 1, marginLeft: "2px" }}>×</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}

            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddUsers;
